import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/UI/Typography';
import moment from 'moment';

const getLastCompleteStep = (steps) => {
  if (!steps) return null;
  for (let i = 0; i < steps.resources().length(); i++) {
    const step = steps.resources().index(i);

    if (step.attr('completed') === 'true') {
      return step;
    }
  }
  return null;
};

function LastSaveTimestamp({ classes, steps }) {
  const lastComplete = getLastCompleteStep(steps);

  if (!lastComplete) {
    return null;
  }

  return (
    <div className={classes.root}>
      <Typography className={classes.label} color="primary">{'Last Saved'}</Typography>
      <Typography className={classes.timestamp} color="primaryGray">{moment(lastComplete.attr('lastSaved')).format('LLL')}</Typography>
    </div>
  );
}

LastSaveTimestamp.propTypes = {
  classes: PropTypes.object.isRequired,
  steps: PropTypes.object.isRequired,
};

export default withStyles(theme => ({
  root: {
    padding: theme.spacing(3, 1),
  },
  label: {
    fontSize: 16,
    fontWeight: theme.typography.fontWeightBold,
  },
}))(LastSaveTimestamp);
